export * from '../utils-react-router'
export * from './encoders'
export * from './ensureUniqueObjectIds'
export * from './formatters'
export * from './hooks'
export * from './isMac'

// TODO: This is duplicated here to help with the migration of the deprecated utils-type-guards
export const filterMaybe = <T>(value: T | null | undefined | void): value is T => value != null

export type Maybe<T> = T | null | undefined | void
export type SetMaybe<T> = { [K in keyof T]?: Maybe<T[K]> }
